module.exports = __webpack_public_path__ + "media/images/mobile/home/banner4-f4e4256d197a24095981a72796ed8ef4.jpg";